/**
 * Branded id primitives (MathToolImplementation.md §2 + §6.1).
 *
 * Id-like strings are branded so the compiler keeps claim-ids, constraint-ids,
 * edge-ids and message-ids from being confused at call sites. The brand is a
 * compile-time-only phantom field (`__k`); at runtime these values are plain
 * strings, so branding adds zero runtime cost and zero dependencies.
 */
/**
 * Generic brand helper (the `brand<T>()` of §2). Use the typed constructors
 * below in preference; this exists for cases where the brand is generic.
 */
export const brand = (s) => s;
export const constraintId = (s) => s;
export const claimId = (s) => s;
export const edgeId = (s) => s;
export const messageId = (s) => s;
//# sourceMappingURL=ids.js.map